import styled from 'styled-components';
import { StyledWidgetHeader } from 'components/base/common-styles';

export const StyledHeader = styled(StyledWidgetHeader)`
  display: flex;
  align-items: flex-start;
  width: 100%;
  & svg#Bulb {
    margin-right: 0.5rem;
    position: relative;
    bottom: 0.2rem;
  }
`;
